import { PrescriptionInterface } from '../interfaces';
import { createTableColumns } from '../utils';

import Axios from "../libraries/axios";

class PrescriptionModel implements PrescriptionInterface {
	[key: string]: any
	timestamp = 0;
	event_type = '';
	test = false;
	metadata = '';
	encounter_id = '';
	case_id = '';
	prescriptions = [];
	services = [];
	patient_id = '';
	internal_id = '';

	constructor(props: PrescriptionInterface) {
	  if (props) {
	    Object.assign(this, props);
	  }
	}

	static getColumns() {
	  return createTableColumns(['event_type', 'prescription', 'patient_name', 'patient_email', 'createdAt']);
	}

	static async getUserPrescriptions(id: string): Promise<any> {
	  const { data } = await Axios.get(`/api/prescriptions?internal_id=${id}&$sort[createdAt]=-1`);
	  return data;
	}

	static async fetchAll<ReturnType>(
	  params: any = {},
	  config: any = {}
	): Promise<ReturnType> {
	  try {
	    const { data } = await Axios.get('/api/prescriptions', {
	      params,
	      ...config,
	    });

	    data.data.map((item: { [key: string]: any }) => {
	      item.prescription = item.prescriptions[item.prescriptions.length - 1].title;
	      return item;
	    });

	    return data;
	  } catch (e: any) {
	    throw new Error(e);
	  }
	}
}

export default PrescriptionModel;
